import BaseProxy from './Proxy';

export default class SubstoreInternalCatalogueProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/internalcatalogue', parameters);
  }

  book(subscriptionTemplateId) {
    return this.submit('post', `${this.endpoint}/book/`, { subscriptionTemplateId });
  }
}
